import { render, staticRenderFns } from "./publiccase-manage-pending.vue?vue&type=template&id=2aeca648&scoped=true"
import script from "./publiccase-manage-pending.vue?vue&type=script&lang=ts"
export * from "./publiccase-manage-pending.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeca648",
  null
  
)

export default component.exports